import { gql } from '@apollo/client';
const UPDATE_SIZE_STANDARD_NAME = gql `
  mutation UpdateSizeStandardName($modelSpecificationSizeStandardId: ID!, $name: String!) {
    updateModelSpecificationSizeStandard(
      modelSpecificationSizeStandardId: $modelSpecificationSizeStandardId
      name: $name
    ) {
      modelSpecificationSizeStandard {
        id
        name
      }
    }
  }
`;
export default UPDATE_SIZE_STANDARD_NAME;
